const forms = [
  {
    name: "Inventory transfer",
    className: "bg-white p-4 rounded-md p-8 w-[90%] mx-auto",
    options: [
      {
        name: "Branch",
        type: "selectandadd",
        path: "/app/suppliers/add",
        form: {
          name: "supplier",
          allowClear: true,
          showSearch: true,
          filterOption: false,
          placeholder: "Branch",
          api: "get-all-sub-branches",
          options: null,
          value: null,
          required: true,
        },
      },
      {
        name: "Number",
        type: "input",
        form: {
          type: "text",
          name: "number",
          placeholder: "Transfer number",
          class: "",
          value: "",
          required: false,
        },
      },
      {
        name: "Date",
        type: "date",
        form: {
          type: "text",
          name: "date",
          placeholder: "Purchase returns date",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Due Date",
        type: "due_date",
        form: {
          type: "text",
          name: "due_date",
          placeholder: "Purchase returns due date",
          class: "",
          value: "",
          required: true,
        },
      },
      {
        name: "Status",
        type: "select",
        form: {
          name: "status",
          allowClear: false,
          placeholder: "Status",
          value: 1,
          options: [
            {
              value: 1,
              label: "Active",
            },
            {
              value: 0,
              label: "In-active",
            },
          ],
          required: false,
        },
      },
    ],
  },
];

export default forms;
